"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = _interopRequireDefault(require("./styles"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Divider = ({
  className,
  color,
  subtle,
  margin,
  height,
  lightGray,
  css
}) => {
  return (0, _jsxRuntime.jsx)("hr", {
    className: className,
    css: theme => [_styles.default.default(color), subtle && _styles.default.subtle(theme), margin && _styles.default.margin(margin), height && _styles.default.height(height), lightGray && _styles.default.lightGray, css && css]
  });
};
var _default = exports.default = Divider;